/* This is the EMIS Student for secondary school components */
<template>
  <v-container>
    <div>
      <span v-html="title + ' ' + curacc + ' ' + ctitle"></span>
    </div>
    <div>
      <table
        style="height: 87px; width: 850px"
        border="1px;"
        cellspacing="0px;"
      >
        <tbody>
          <tr>
            <td class="col-title" rowspan="3">
              សិស្សភៀសសឹក
            </td>
            <td class="row-header-title" colspan="4">ថ្នាក់ទី ៧</td>
            <td class="row-header-title" colspan="4">ថ្នាក់ទី ៨</td>
            <td class="row-header-title" colspan="4">ថ្នាក់ទី ៩</td>
            <td class="row-header-title" colspan="4">
              សរុបសិស្សមធ្យមសិក្សាបឋមភូមិ
            </td>
          </tr>
          <tr>
            <td class="row-header" colspan="2">សិស្សថ្មី</td>
            <td class="row-header" colspan="2">សិស្សត្រួតថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សឡើងថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សត្រួតថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សឡើងថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សត្រួតថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សឡើងថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សត្រួតថ្នាក់</td>
          </tr>
          <tr>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
          </tr>
          <!-- Data row -->
          <tr v-for="(value, row) in priMig.length" :key="row">
            <!-- Draw only 16 columns -->
            <td class="col-title">{{ priMig[row] }}</td>
            <td
              v-for="(value, col) in data[row].dt.length"
              :key="col"              
            >
              <numberinput
                v-model="data[row].dt[col]"                
                class="number"
              />
            </td>
            <!-- total in each row -->
            <td class="row-data">
              <strong>{{ col1[row] }}</strong>
            </td>
            <td class="row-data">
              <strong>{{ col2[row] }}</strong>
            </td>
            <td class="row-data">
              <strong>{{ col3[row] }}</strong>
            </td>
            <td class="row-data">
              <strong>{{ col4[row] }}</strong>
            </td>
          </tr>          
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import NumberInput from "@/components/common/NumberInput.vue";
import { priMig } from "@/utils/ascf/priConfig.js";
export default {
  props: ["data", "curacc", "title", "ctitle"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      priMig: priMig
    };
  },
  // Compute function for student sec
  computed: {
    /* col1, col2, col3 and col4 are computed function in each row by age and total/gender */
    col1: function () {
      let result;
      let d = this.data;
      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (i % 4 === 0) {
            r[ind] = (r[ind] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      return result;
    },
    col2: function () {
      let result;
      let d = this.data;
      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (i % 4 === 1) {
            r[ind] = (r[ind] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      return result;
    },
    col3: function () {
      let result;
      let d = this.data;
      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (i % 4 === 2) {
            r[ind] = (r[ind] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      return result;
    },
    col4: function () {
      let result;
      let d = this.data;
      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (i % 4 === 3) {
            r[ind] = (r[ind] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      return result;
    },
  },
  filters: {
    blank: function (value) {
      if (value == 0) return "0";
      return value;
    },
  },
};
</script>

<style scoped>
.number {
  width: 50px;
  text-align: center;
}
.row-data {
  width: 50px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.row-data-gray {
  width: 50px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
  background-color: lightgray;
}
.row-header {
  width: 100px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.row-header-title {
  width: 200px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.col-title {
  width: 50px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
</style>